import moment from 'moment';


let campaigns = [];

let pas;
let startYear = new Date().getFullYear();


let date = moment(`${startYear}0701`).diff(moment(), 'days');

var dateCurrentCampaign = new Date(`${startYear}-07-01`);

var dateFormated = moment(dateCurrentCampaign).format("DD/MM/YYYY")

if(date > 0) startYear--;

for (pas = startYear; pas > (startYear - 5); pas--) {
    campaigns.push({value : pas, name : pas, label : pas, curerentCampaign : dateFormated});
}







const CONFIG = {


    author : {
        name : 'Whatson web',
        url : 'https://www.whatson-web.com'
    },
    costumer : {
        name : 'Vaesken',
        url : 'https://www.vaesken.fr'

    },
    ROLES : [
        {value: 'ROLE_USER', label: 'Membre'},
        {value: 'ROLE_TCP', label: 'TCP'},
        {value: 'ROLE_ADMIN', label: 'Administeur'},
        {value: 'ROLE_ADV', label: 'Administeur de ventes'}
    ],
    SELLERS_TYPE : [
        {value: 100, label: 'Vendeur Appro', name: 'Vendeur Appro'},
        {value: 200, label: 'Vendeur Aliment', name: 'Vendeur Aliment'},
        {value: 1, label: 'Admin', name: 'Admin'}
    ],
    TYPE_POST : [
        {value: 'news', label: 'Quoi de neuf', name: 'Quoi de neuf'},
        {value: 'actu', label: 'Actu vaesken', name: 'Actu vaesken'}
    ],
    CAMPAIGNS : campaigns

}

module.exports = CONFIG;



// WEBPACK FOOTER //
// ./src/constants/parameters.js